// Stub for getSvgs (223 svg modules) — light pages only use the 'welcome' glyph.
// Swapped in via NormalModuleReplacementPlugin; add a glyph here if needed.
import welcome from '@ringcentral/rcv-ui/src/img/welcome.svg';

export default { welcome };
